<template>
	<button class="my-button" @click="$emit('click', $event)" @mousedown="$emit('mousedown', $event)">
		<slot></slot>
	</button>
</template>

<script>
	export default {
		name: 'my-button',
		props: {
			disabled: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			style() {
				if (this.disabled) {
					return 'cursor: not-allowed;';
				}
				return '';
			}
		}
	}
</script>

<style scoped lang="less">
	.my-button{
		background-position: center center;
		background-repeat: no-repeat;
		-webkit-background-size: 100% 100%;
		background-size: 100% 100%;
		background-color: transparent;
		position: relative;
		font-size: 1.6rem;
		overflow: hidden;
		cursor: pointer;
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		&::before{
			content: '';
			display: block;
			position: absolute;
			height: 100%;
			width: 100%;
			left: 0;
			top: 0;
			pointer-events: none;
			// border-radius: inherit;
			background-repeat: no-repeat;
			background-position: 50%;
			transform: scale(2);
			opacity: 0;
			transition: transform 500ms, opacity 800ms;
			background-image: radial-gradient(circle, #FFFFFF 50%, transparent 50%);
		}
		&:active::before{
			transform: scale(0);
			opacity: .5;
			transition: 0s;
		}
	}
</style>
